export class Holiday {
    id: number;
    date: string;
    name: string;
}
